<template>
  <div class="min-transfer-duration">
    Minimale Umsteigezeit:
    <a class="link-light" data-bs-toggle="tooltip" :data-bs-title="tooltipString" ref="tooltip">
      <time-duration class="d-inline" :duration="transferTime" :inline="true"></time-duration>
    </a>
    {{ platformString }}
  </div>
</template>

<script setup lang="ts">
import { onMounted, useTemplateRef, computed } from 'vue'
import dayjs from 'dayjs'
import { Tooltip } from 'bootstrap'
import TimeDuration from '~/components/TimeDuration.vue'

import { type Transfer } from '~/types/fptfTypes'

const props = defineProps<{
  transfer: Transfer
}>()

const transferTime = computed(() => {
  let transferDuration = dayjs.duration(props.transfer.duration)
  if (transferDuration < dayjs.duration({ minutes: 1 })) {
    transferDuration = dayjs.duration({ minutes: 1 })
  }
  return transferDuration
})

const platformString = computed(() => {
  if (props.transfer.identicalPhysicalPlatform) {
    return ' (gleicher Bahnsteig)'
  } else {
    return ''
  }
})

const tooltipString = computed(() => {
  switch (props.transfer.source) {
    case 'RIL420':
      return 'Quelle: Interne Richtlinie 420 der DB. In der Regel ist diese Zeit ziemlich großzügig bemessen.'
    case 'INDOOR_ROUTING':
      return 'Quelle: Wegberechnung der DB. In der Regel ist diese Zeit sehr knapp bemessen.'
    case 'EFZ':
      return 'Quelle: Europäisches Fahrplanzentrum. In der Regel ist diese Zeit ziemlich großzügig bemessen.'
    case 'FALLBACK':
      return 'Keine Umsteigezeiten bekannt. Mindestumsteigezeit angenommen.'
    case 'HAFAS':
      return 'Quelle: HAFAS Fahrplanauskunft. In der Regel ist diese Zeit ziemlich großzügig bemessen.'
    default:
      return ''
  }
})

const tooltip = useTemplateRef('tooltip')

onMounted(() => {
  new Tooltip(tooltip.value!)
})
</script>

<style>
.min-transfer-duration {
  grid-area: min-transfer-duration;
}
</style>
